import Image from 'next/image'
import { Sponsor } from 'domain/models/Sponsor/Sponsor'

interface SponsorImageProps {
  sponsor: Sponsor
}

const SponsorImage = ({ sponsor }: SponsorImageProps) => {
  return (
    <Image
      src={`data:image/png;base64,${sponsor.imageCta}`}
      alt={sponsor.name}
      width={375}
      height={185}
      style={{ width: '100%', height: 'auto' }}
    />
  )
}

export default SponsorImage
